export const AppFonts = {
  regular: "GWP Regular",
  bold: "GWP Bold",
  light: "GWP Light",
  medium: "GWP Medium",
  thin: "GWP Thin",
};
